<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Examination Fees
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" persistent max-width="400">
              <v-form ref="form">
                <v-card>
                  <v-card-title>Edit ExamFees for Grade Level {{ editedItem.gradeLevel}}</v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col>
                          <v-text-field
                            v-model="editedItem.regularFee"
                            type="number"
                            label="Regular Fee"
                            :rules="feeRules"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="editedItem.retryFee"
                            type="number"
                            label="Retry Fee"
                            :rules="feeRules"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="editedItem.lateFee"
                            type="number"
                            label="Late Fee"
                            :rules="feeRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="close">Cancel</v-btn>
                    <v-btn color="primary" @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>
            <ReturnHomeBtn />
          </v-card-title>
          <v-data-table :headers="headers" :items="examFees">
            <template v-slot:item.actions="{ item }">
              <v-layout :justify-end="true">
                <v-icon class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              </v-layout>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { errorMessageMixin } from "../shared";

import ReturnHomeBtn from "../components/ReturnHomeBtn.vue";

export default {
  name: "Fees",
  mixins: [errorMessageMixin],
  components: { ReturnHomeBtn },
  computed: {
    ...mapState(["examFees"])
  },
  data() {
    return {
      headers: [
        { text: "Grade Level", value: "gradeLevel" },
        { text: "Regular Fee", value: "regularFee" },
        { text: "Retry Fee", value: "retryFee" },
        { text: "Late Fee", value: "lateFee" },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          align: "end"
        }
      ],
      editedIndex: -1,
      editedItem: {},
      dialog: false,
      feeRules: [v => (!!v && v > 0) || "Must be greater than 0"]
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    ...mapActions(["updateExamFeeAction"]),
    editItem(item) {
      console.log("im in edit", item);
      this.editedIndex = this.examFees.indexOf(item);
      this.editedItem = Object.assign({}, item);
      console.log("this.editedItem", this.editedItem);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = {};
        this.editedIndex = -1;
      }, 300);
    },
    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.$store.state.fullScreenLoading = true;

      try {
        const model = {
          id: this.editedItem.id,
          regularFee: this.editedItem.regularFee,
          retryFee: this.editedItem.retryFee,
          lateFee: this.editedItem.lateFee
        };

        await this.updateExamFeeAction({
          model: model,
          token: this.$store.state.token
        });
        this.close();
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
      this.$store.state.fullScreenLoading = false;
    }
  }
};
</script>